module.exports = __webpack_public_path__ + "img/example.13d2cb41.png";